// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3W7SU","text":"styles_text__3ah-M","closeButton":"styles_closeButton__3niRH"};